import { defineFcm } from '../shared/factory';

export const FCM_PROMOTED_SIGNATURE_RECEIPT_EMAIL_PROMOTION_COUNT = defineFcm(
	'promoted_signature_receipt_email_promotion_count',
)
	.asNumber()
	.withDefault(undefined)
	.toConfig();
